import { rdEquipamentosService } from '@/services/quotes/rd-equipamentos';
import { STALE_TIME_FIVE_MINUTES_MS } from '@/shared/constants/query-stale-time.constants';
import { useQuery } from '@tanstack/react-query';

export function useRdFrotaPlanos() {
  return useQuery({
    queryKey: ['rd-frota-planos'],
    queryFn: async () => {
      const response = await rdEquipamentosService.getFrotaPlanos();
      if (!response.success || !response.data) {
        throw new Error(
          response.error || 'Erro ao carregar os planos de frota do produto'
        );
      }

      return response.data;
    },
    staleTime: STALE_TIME_FIVE_MINUTES_MS,
  });
}
